import React from 'react'
import PropTypes from 'prop-types';

function moveNextHandler(event, setCurrentPage) {
    let currentPage = event.target.id;
    setCurrentPage(
        currentPage
    );
    event.preventDefault();
}

function nextPage(event, setCurrentPage, currentPage) {
    setCurrentPage(
        Number(currentPage) + 1
    );
    event.preventDefault();
}
function prevPage(event, setCurrentPage, currentPage) {
    setCurrentPage(
        Number(currentPage) - 1
    );
    event.preventDefault();
}


function Pagination(props) {
    let numberOfPages = [];
    for (let i = 1; i <= Math.ceil(props.filteredCoursesPage.length / props.itemsPerPage); i++) {

        numberOfPages.push(i);
    }

    let pages = numberOfPages.map((pageNumber) => {
        return (
            <button className={Number(props.currentPage) === pageNumber ? "isActive" : ""} id={pageNumber}  key={pageNumber} onClick={event => moveNextHandler(event, props.setCurrentPage)}>{pageNumber}</button>
        )
    })
    return (
        <ul className="pagination">

            <button disabled={props.currentPage == 1} onClick={event => prevPage(event, props.setCurrentPage, props.currentPage)}>{"<"}</button>
            {pages}
            <button className = "buttonarrow" disabled={props.currentPage == numberOfPages.length} onClick={event => nextPage(event, props.setCurrentPage, props.currentPage)}>{">"}</button>
        </ul>
    );

}
Pagination.propTypes = {
    filteredCoursesPage: PropTypes.array,
    itemsPerPage: PropTypes.number,
    currentPage: PropTypes.number,
    setCurrentPage: PropTypes.func,
};

export default Pagination;